// extracted by mini-css-extract-plugin
module.exports = {"root":"interviewCard_root__2L8e8","bullet":"interviewCard_bullet__27mYl","title":"interviewCard_title__46m8S","pos":"interviewCard_pos__2_tXm"};